import { css, Theme } from '@mui/material'

export const guideItemBox = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #d9d9d9;
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  padding: 12px;

  &:hover {
    background-color: #d2e9fa;
    border-top: 1px solid #d9d9d9;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    color: #d2e9fa;
  }
`

export const guideItemTypography = css`
  color: #000;
  font-weight: 400;
`

export const guideItemIcon = (theme: Theme) => css`
  color: ${theme.palette.blue.light};
  font-weight: 900;
`

export const guideItemsContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 70rem;
  padding-right: 40px;

  & > a:last-of-type > div {
    border-bottom: 1px solid #d9d9d9;
  }
`

export const guideCardContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 70rem;
  padding-right: 40px;
  gap: 20px;

  & > a:last-of-type > div {
    border-bottom: 1px solid #d9d9d9;
  }

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }
`
